"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayStoreIconButton = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var icons_1 = require("../icons");
var types_1 = require("../icons/types");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    base: {
        backgroundColor: 'transparent',
        outline: 'none',
        borderColor: 'none',
        border: 'none',
        cursor: 'pointer',
        height: 'fit-content',
        width: 'fit-content',
        padding: 0,
        margin: 0,
    },
}); });
var PayStoreIconButton = function (_a) {
    var className = _a.className, storeName = _a.storeName, onClick = _a.onClick, height = _a.height, width = _a.width, backgroundColor = _a.backgroundColor, color = _a.color, borderColor = _a.borderColor;
    var classes = useStyles();
    var renderIcon = function () {
        switch (storeName) {
            case types_1.StoreNames.Apple: {
                return (react_1.default.createElement(icons_1.Icon.Creative.AppleStoreIcon, { backgroundColor: backgroundColor, color: color, borderColor: borderColor, height: height, width: width }));
            }
            case types_1.StoreNames.Google: {
                return (react_1.default.createElement(icons_1.Icon.Creative.GoogleStoreIcon, { backgroundColor: backgroundColor, color: color, borderColor: borderColor, height: height, width: width }));
            }
        }
    };
    return (react_1.default.createElement("button", { className: (0, clsx_1.default)(classes.base, className), onClick: onClick, type: 'button' }, renderIcon()));
};
exports.PayStoreIconButton = PayStoreIconButton;
